module.exports = __webpack_public_path__ + "img/f007258.jpg";